import type { AdLinkState } from './AdLinks.types';

export const INIT_STATE: AdLinkState = {
  links: undefined,
  hasLinksLoaded: false,
};
